import { render, staticRenderFns } from "./AddTagsDialog.vue?vue&type=template&id=50fc87bf"
import script from "./AddTagsDialog.ts?vue&type=script&lang=js&external"
export * from "./AddTagsDialog.ts?vue&type=script&lang=js&external"
import style0 from "./AddTagsDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports